import { MutationTree } from 'vuex';
import * as MT from './mutationsTypes';
import {
  AggregatedForecastItem,
  ForecastFilter,
  PaginatedForecastResult
} from '../types';
import { PensionScheme } from '../../pensionScheme/types';
import { IForecastState } from './state';

/*--------------------------------------------------/
 * Forecast Mutations
 *--------------------------------------------------*/
export const ForecastMutations: IForecastMutations = {
  [MT.SET_FORECAST]: (
    state: IForecastState,
    forecast: PaginatedForecastResult
  ) => (state.forecast = forecast),
  [MT.SET_FORECAST_FILTERS]: (
    state: IForecastState,
    forecastFilters: ForecastFilter
  ) => (state.forecastFilters = forecastFilters),
  [MT.SET_ORGANISATION_CLIENTS]: (
    state: IForecastState,
    organizationClients: PensionScheme[]
  ) => (state.organizationClients = organizationClients),
  [MT.SET_AGGREGATED_FORECAST_DETAILS]: (
    state: IForecastState,
    aggregatedForecastDetails: AggregatedForecastItem[]
  ) => (state.aggregatedForecastDetails = aggregatedForecastDetails)
};

/*--------------------------------------------------/
 * Forecast Mutations Tree Interface
 *--------------------------------------------------*/
export interface IForecastMutations extends MutationTree<IForecastState> {
  [MT.SET_FORECAST](
    state: IForecastState,
    forcast: PaginatedForecastResult
  ): void;
  [MT.SET_FORECAST_FILTERS](
    state: IForecastState,
    forecastFilters: ForecastFilter
  ): void;
  [MT.SET_ORGANISATION_CLIENTS](
    state: IForecastState,
    organizationClients: PensionScheme[]
  ): void;
  [MT.SET_AGGREGATED_FORECAST_DETAILS](
    state: IForecastState,
    aggregatedForecastDetails: AggregatedForecastItem[]
  ): void;
}
